import _ from 'lodash';
export const name = 'DEFAULT.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    // TODO: BIO_UK 这次不支持
    const cellValue = _.get(row, prop) || '';
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            <span 
        // @ts-ignore
        domProps={{
                innerHTML: _highlightMixin_hlText(cellValue),
            }}>
            </span>
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
